<template>
	<i class="fa-solid fa-arrow-left"></i>
</template>

<script>
export default {
	name: "ArrowLeftIcon",
	props: {
		fillColor: String,
	},
};
</script>
